import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Modal, Table, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import mdmService from '../../services/MDMService';
import dayjs from 'dayjs';
import RegLibFurtherQuery from '../../components/regulations/regLibFurtherQuery';
import { useSelector } from 'react-redux';
import commonService from "../../services/CommonService";
import { UserActivity } from "../../config/BVConstants";
const RegulationQueryDetail = () => {
    var _a, _b, _c, _d;
    const { regulationLibraryId } = useParams();
    const [objRegulatoryLibrary, setObjRegulatoryLibrary] = useState({});
    const [expandedDescRowKeys, setExpandedDescRowKeys] = useState([]);
    const [expandedResRowKeys, setExpandedResRowKeys] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [sortedInfo, setSortedInfo] = useState({});
    const [openFurtherQueryDialog, setOpenFurtherQueryDialog] = useState(false);
    const [lstRegulatoryQuery, setLstRegulatoryQuery] = useState();
    const [record, setRecord] = useState();
    const [question, setQuestion] = useState();
    const applicationData = useSelector((state) => state.applicationData);
    const navigate = useNavigate();
    const boolScreenAccessCheck = ((_d = (_c = (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.getClientUserScreenAccess) === null || _a === void 0 ? void 0 : _a.lstClientUserCompanies) === null || _b === void 0 ? void 0 : _b.find((obj) => { var _a, _b; return obj.intId === ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID); })) === null || _c === void 0 ? void 0 : _c.lstObjLuScreens) === null || _d === void 0 ? void 0 : _d.find((obj) => obj.intId === 5)) != undefined;
    useEffect(() => {
        var _a, _b, _c, _d;
        if (!boolScreenAccessCheck) {
            navigate('/no-access');
            return;
        }
        else if ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId) {
            commonService
                .logUserActivity((_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.strUserEmailId, UserActivity.CP__RegLibDetails_QA_Visited);
        }
        if (regulationLibraryId) {
            setIsLoading(true);
            mdmService
                .getRegLibraryQueryDetail({ strRegLibId: atob(regulationLibraryId), intCompanyID: 2132708 })
                .then((res) => {
                setObjRegulatoryLibrary(res);
                setLstRegulatoryQuery(res.lstRegLibrarySaveQuery);
                setIsLoading(false);
            });
        }
    }, []);
    const handleExpand = (key, field) => {
        if (field === 'desc') {
            setExpandedDescRowKeys((prevKeys) => prevKeys.includes(key) ? prevKeys.filter((k) => k !== key) : [...prevKeys, key]);
        }
        if (field === 'res') {
            setExpandedResRowKeys((prevKeys) => prevKeys.includes(key) ? prevKeys.filter((k) => k !== key) : [...prevKeys, key]);
        }
    };
    const formatDate = (date) => {
        const formattedDate = date === null || date === undefined
            ? null
            : dayjs(date, 'DD/MM/YYYY hh:mm:ss').format('DD-MMM-YYYY');
        return formattedDate;
    };
    const handleChange = (pagination, filters, sorter) => {
        setSortedInfo(sorter);
    };
    const handleInputChange = (e) => {
        setQuestion(e.target.value);
    };
    const submitFurtherQuery = () => {
        var _a, _b, _c, _d, _e, _f;
        const objShareFutherQuery = JSON.parse(JSON.stringify(record));
        objShareFutherQuery['strQueryDescription'] = question;
        objShareFutherQuery['strClientLoggedInUser'] =
            (_b = (_a = applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserName;
        objShareFutherQuery['strClientLoggedInUserEmail'] = 'test@123.com';
        objShareFutherQuery['intCompanyID'] =
            (_d = (_c = applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.intCompanyID;
        mdmService.shareRegLibFurtherQuery(objShareFutherQuery).then((res) => {
            Modal.success({
                title: 'Query has been submitted successfully.',
                centered: true,
                content: _jsx(_Fragment, { children: "Our SME will provide answer to your question." })
            });
            setOpenFurtherQueryDialog(false);
        });
        commonService
            .logUserActivity((_f = (_e = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _e === void 0 ? void 0 : _e.userLoginDetails) === null || _f === void 0 ? void 0 : _f.strUserEmailId, UserActivity.CP__RegLibDashboard_Raise_Further_Query);
    };
    const columns = [
        {
            title: 'Query ID',
            width: '10%',
            dataIndex: 'strRegLibQueryId',
            key: 'strRegLibQueryId'
            // sorter: (a, b) => a.strRegLibQueryId.length - b.strRegLibQueryId.length,
            // sortOrder: sortedInfo.columnKey === 'strRegLibQueryId' ? sortedInfo.order : null,
            // ellipsis: true,
        },
        {
            title: 'Submitted Date',
            width: '10%',
            dataIndex: 'dtSubmittedDate',
            key: 'dtSubmittedDate',
            render: (text, record) => formatDate(text.toString())
        },
        {
            title: 'Status',
            width: '10%',
            dataIndex: ['objLuStatus', 'strLongDesc'],
            key: 'objLuStatus',
            render: (text, record) => (_jsxs(_Fragment, { children: [text, record.objLuStatus.intId !== 1 ? (record.dtLastUpdatedDate ? (_jsxs(_Fragment, { children: [_jsx("br", {}), "(", formatDate(record.dtLastUpdatedDate.toString()), ")"] })) : ('')) : ('')] }))
        },
        {
            title: 'Query Description',
            width: '35%',
            dataIndex: 'strQueryDescription',
            key: 'strQueryDescription',
            render: (text, record) => (_jsx("div", { style: { textAlign: 'justify' }, children: expandedDescRowKeys.includes(record.strRegLibQueryId) ? (text) : text && text.length > 210 ? (_jsxs(_Fragment, { children: [`${text.slice(0, 210)}... `, _jsx(Typography.Link, { onClick: () => handleExpand(record.strRegLibQueryId, 'desc'), strong: true, children: expandedDescRowKeys.includes(record.strRegLibQueryId) ? ' Read Less' : 'Read More' })] })) : (text) }))
        },
        {
            title: 'Response',
            width: '35%',
            dataIndex: 'strResponse',
            key: 'strResponse',
            render: (text, record) => (_jsx(_Fragment, { children: record.objLuStatus.intId === 1 ? ('Our Subject Matter Expert is reviewing your question. Please wait for the response.') : record.objLuStatus.intId !== 1 ? (_jsxs(_Fragment, { children: [_jsx("div", { style: { textAlign: 'justify' }, children: expandedResRowKeys.includes(record.strRegLibQueryId) ? (text) : text && text.length > 210 ? (_jsxs(_Fragment, { children: [`${text.slice(0, 210)}... `, _jsx(Typography.Link, { onClick: () => handleExpand(record.strRegLibQueryId, 'res'), strong: true, children: expandedResRowKeys.includes(record.strRegLibQueryId)
                                            ? ' Read Less'
                                            : 'Read More' })] })) : (text) }), _jsx(Typography.Text, { children: "For further queries, please " }), _jsx(Typography.Link, { onClick: () => {
                                setQuestion('');
                                setRecord(record);
                                setOpenFurtherQueryDialog(true);
                            }, children: "Click Here" })] })) : ('') }))
        }
    ];
    return (_jsxs(Card, { style: { borderRadius: '0px' }, title: 'Regulation Library Query', children: [_jsx(RegLibFurtherQuery, { data: record, regLibDetail: objRegulatoryLibrary, open: openFurtherQueryDialog, onClose: () => setOpenFurtherQueryDialog(false), handleInputChange: handleInputChange, question: question, submitFurtherQuery: submitFurtherQuery }), _jsx(Typography.Title, { level: 5, children: objRegulatoryLibrary.strTitle }), _jsx(Table, { columns: columns, loading: isLoading, dataSource: lstRegulatoryQuery, onChange: handleChange, scroll: { x: 800 }, pagination: { position: ['bottomLeft'], defaultPageSize: 10 } })] }));
};
export default RegulationQueryDetail;
